import TemplateView from 'picnic/core/views/Template';
import Template from 'app/cms/carpricechecker/views/modelSelect/Option.html';


class View extends TemplateView {
	get template() {
		return Template;
	}

	render() {
		super.render();

		this.el.value = this.model.get('value');

		return this;
	}
}

export default View;
